import { Box, Button, Typography } from '@mui/material';
import { CheckCircleOutlineRounded } from '@mui/icons-material';

import { Title } from './styles';

import { AuthSectionSteps } from '../../types/AuthSectionSteps';

import useAuthStore from '../../../../store/auth';

interface StepRecoverSuccessProps {
  setStepLogin: (type: AuthSectionSteps) => void;
}

export const StepRecoverSuccess = ({
  setStepLogin,
}: StepRecoverSuccessProps) => {
  const { user } = useAuthStore(state => state);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="11px"
      width="100%"
    >
      <CheckCircleOutlineRounded
        sx={{ width: '80px', height: '80px', color: '#4CAF50;' }}
      />
      <Title>Solicitação de senha enviada!</Title>
      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: '700',
          color: '212121',
          textAlign: 'center',
        }}
      >
        Enviamos as instruções para você recuperar sua senha no e-mail{' '}
        <span style={{ color: '#206DA7' }}>{user?.email}.</span>
      </Typography>
      <Typography
        sx={{
          color: '#9E9E9E',
          fontSize: '14px',
          fontWeight: '400',
          width: '290px',
          textAlign: 'center',
        }}
      >
        Obs: Caso não encontre, verifique sua caixa de spam.
      </Typography>
      <Button
        variant="outlined"
        sx={{ height: '54px', marginTop: '20px' }}
        onClick={() => setStepLogin(AuthSectionSteps.LOGIN)}
      >
        Voltar ao Login
      </Button>
    </Box>
  );
};
